import React from 'react';
import { PDFIcon } from '../../../../components/Icon/Icon';

const Body = () => (
    <>
        <h1>
            <a href="/corporate-governance" className="selected">
                Our Committees
            </a>
            <span>/</span>
            <a href="/corporate-governance/our-policies">Our Policies</a>
        </h1>
        <h2>Our Committees</h2>
        The Board delegates certain powers to Board Committees. There are three principal Board Committees to which the
        Board has delegated certain of its responsibilities. The terms of reference for all three Committees are
        reviewed by each Committee regularly and can be downloaded here:
        <ul className="column">
            <li>
                <a
                    href="https://files.jdplc.com/pdf/terms-of-reference-audit-committee-2016.pdf"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <PDFIcon name="our-committees/audit-committee.png" />
                    Terms of Reference Audit Committee
                </a>
            </li>
            <li>
                <a
                    href="https://files.jdplc.com/pdf/terms-of-reference-nominations-committee-2016.pdf"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <PDFIcon name="our-committees/nomination-committee.png" />
                    Terms of Reference Nomination Committee
                </a>
            </li>
            <li>
                <a
                    href="https://files.jdplc.com/pdf/terms-of-reference-remuneration-committee-2016.pdf"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <PDFIcon name="our-committees/renumeration-committee.png" />
                    Terms of Reference Remuneration Committee
                </a>
            </li>
        </ul>
        <h2>Audit Committee</h2>
        The Audit Committee currently comprises three independent Non - Executive Directors; Helen Ashton, Bert Hoyt and
        Kath Smith. The Audit Committee is chaired by Helen Ashton.
        <br />
        <br />
        The principal duties of the Audit Committee are to review draft annual and interim financial statements prior to
        being submitted to the Board, reviewing the effectiveness of the Group’s system of internal control, risk
        management and the performance and cost effectiveness of the external auditor.
        <br />
        <br />
        Read more about our Audit Committee in our{' '}
        <a
            className="link"
            href="https://files.jdplc.com/pdf/reports/annual-report-2021.pdf"
            title="Annual Report"
            target="_blank"
            rel="noopener noreferrer"
        >
            Annual Report
        </a>
        .<h2>Nomination Committee</h2>
        The Nomination Committee currently comprises Peter Cowgill, the Executive Chairman, and three independent
        Non-Executive Directors: Bert Hoyt, Helen Ashton and Kath Smith. Kath Smith is the Chair of the Nomination
        Committee.
        <br />
        <br />
        The Committee’s principal duties are to consider the size, structure and composition of the Board, ensure
        appropriate succession plans are in place for the Board and senior management and, where necessary, consider new
        appointments to the Board and senior management.
        <br />
        <br />
        Read more about our Nomination Committee in our{' '}
        <a
            className="link"
            href="https://files.jdplc.com/pdf/reports/annual-report-2021.pdf"
            title="Annual Report"
            target="_blank"
            rel="noopener noreferrer"
        >
            Annual Report
        </a>
        .<h2>Remuneration Committee</h2>
        The Remuneration Committee currently comprises three independent Non-Executive Directors: Bert Hoyt, Helen
        Ashton and Kath Smith. Bert Hoyt serves as the Interim Chair of the Remuneration Committee.
        <br />
        <br />
        The Committee’s principal duties are to determine:
        <ul className="list">
            <li>Overall Group remuneration policy;</li>
            <li>Remuneration packages for Executive Directors and senior management;</li>
            <li>The terms of Executive Director service contracts as may be required from time to time; and</li>
            <li>
                The terms of any performance-related and/or long term incentive schemes operated by the Group and awards
                thereunder.
            </li>
        </ul>
        Read more about our Remuneration Committee in our{' '}
        <a
            className="link"
            href="https://files.jdplc.com/pdf/reports/annual-report-2021.pdf"
            title="Annual Report"
            target="_blank"
            rel="noopener noreferrer"
        >
            Annual Report
        </a>
        . Review the{' '}
        <a
            className="link"
            href="https://files.jdplc.com/pdf/LTIP-rules-10-June-21.pdf"
            title="Draft LTIP Rules"
            target="_blank"
            rel="noopener noreferrer"
        >
            Draft LTIP Rules
        </a>{' '}
        of the proposed 2021 LTIP Scheme.
    </>
);

export const content = {
    image: 'https://files.jdplc.com/images/about/our-committees.jpg',
    body: Body,
};
